import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/contact.js';
import {siteConfig} from '../../settings';
import actions from '@iso/redux/contact/actions';
import { useDispatch,useSelector } from 'react-redux';


function Contact() {
    const dispatch = useDispatch();

    const onRecordChange = (event, key) => {
        if (key) fdata[key] = event.target.value;
        dispatch(actions.updateContact(fdata));
    };

    const { fdata, enbaledButtonContact, buttonContact } = useSelector(
        state => state.Contact
      );


    useEffect(() => {
        const form = document.getElementById("form_contact");
        const name = document.getElementById("contact_name");
        const email = document.getElementById("contact_email");
        const subject = document.getElementById("contact_subject");
        const message = document.getElementById("contact_message");

        form.addEventListener("submit", formSubmit);

        function formSubmit(e) {
            e.preventDefault();
            let ok = true;

            const nameValue = name.value.trim();
            const emailValue = email.value.trim();
            const subjectValue = subject.value.trim();
            const messageValue = message.value.trim();

            if (nameValue === "") {
                setError(name, "Nome não pode ficar em branco");
                ok=false;
            } else {
                setSuccess(name);
            }

            if (emailValue === "") {
                setError(email, "E-mail não pode ficar em branco");
                ok=false;
            } else if (!isEmail(emailValue)) {
                setError(email, "E-mail inválido");
                ok=false;
            } else {
                setSuccess(email);
            }

            if (subjectValue === "") {
                setError(subject, "Assunto não pode ficar em branco");
                ok=false;
            } else {
                setSuccess(subject);
            }

            if (messageValue === "") {
                setError(message, "Mensagem não pode ficar em branco");
                ok=false;
            } else {
                setSuccess(message);
            }

            if(ok){
                dispatch(actions.saveContact(fdata));                
            }
        }

        function setError(input, message) {
            const formControl = input.parentElement;
            const errorMsg = formControl.querySelector(".contact_input-msg");
            formControl.className = "form-control text-left error";
            errorMsg.innerText = message;
        }

        function setSuccess(input) {
            const formControl = input.parentElement;
            formControl.className = "form-control success";
        }

        function isEmail(email) {
            return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);
        }
    },[]);

    return (
        <Styles>
            {/* Main Wrapper */}
            <div className="main-wrapper contact-page">

                {/* Header 2 */}
                <HeaderTwo />

                {/* Breadcroumb */}
                <BreadcrumbBox title="Entre em contato" />

                {/* Contact Area */}
                <section className="contact-area">
                    <Container>
                        <Row>
                            <Col md="4">
                                <div className="contact-box-title">
                                    <h4>Informações</h4>
                                </div>
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-map-marker"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>Nossa Localização</h5>
                                        <p>{siteConfig.addressFull}</p>
                                    </div>

                                </div>
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-envelope-open"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>E-mail</h5>
                                        <p>{siteConfig.email}</p>
                                    </div>
                                </div>
                                {/* <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-phone"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>Telefone</h5>
                                        <p>{siteConfig.telefone}</p>
                                    </div>
                                </div> */}
                                <div className="contact-social">
                                    <ul className="social list-unstyled list-inline">
                                    <li className="list-inline-item"><a href={siteConfig.facebook}><i className="fab fa-facebook-f"></i></a></li>
                                    <li className="list-inline-item"><a href={siteConfig.linkedin}><i className="fab fa-linkedin-in"></i></a></li>
                                    <li className="list-inline-item"><a href={siteConfig.instagram}><i className="fab fa-instagram"></i></a></li>
                                    </ul>
                                </div>
                            </Col>
                            <Col md="8">
                                <div className="contact-form">
                                    <div className="form-title">
                                        <h4>Entre em contato!</h4>
                                    </div>
                                    <div className="form-box">
                                        <form id="form_contact" className="form">
                                            <Row>
                                                <Col md="6">
                                                    <p className="form-control">
                                                        <input type="text" placeholder="Nome Completo" id="contact_name" value={fdata.name} onChange={e => onRecordChange(e, 'name')} />
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>
                                                <Col md="6">
                                                    <p className="form-control">
                                                        <input type="email" placeholder="E-mail" id="contact_email" value={fdata.email} onChange={e => onRecordChange(e, 'email')} />
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>
                                                <Col md="12">
                                                    <p className="form-control">
                                                        <input type="text" placeholder="Assunto" value={fdata.assunto} onChange={e => onRecordChange(e, 'assunto')} id="contact_subject" />
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>
                                                <Col md="12">
                                                    <p className="form-control">
                                                        <textarea name="message" id="contact_message" value={fdata.mensagem} onChange={e => onRecordChange(e, 'mensagem')} placeholder="Escreva a mensagem"></textarea>
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>
                                                <Col md="12">
                                                    <button disabled={!enbaledButtonContact}>{buttonContact}</button>
                                                </Col>
                                            </Row>
                                        </form>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* Footer 2 */}
                <FooterTwo />

            </div>
        </Styles>
    )
}

export default Contact